export default __webpack_public_path__ + "static/muferiha-a6c5202e6bde7930e44cfcc4a0723c45.png";